<template>
    <div>
        <loading
                color="green"
                :active="loading"
                spinner="bar-fade-scale"
        />
        <h4 class="text-center">{{text.give_us_details_of_you_and_your_partner}}</h4>
        <div class="row">
            <div class="form-group col-6">
                <input type="text" class="form-control" id="name" name="name" v-model="name"
                       :placeholder="word.your_name">
                <small
                        v-if="errors && errors.name"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.name[0]}}
                </small>
            </div>
            <div class="form-group col-6">
                <input type="text" class="form-control" id="partner_name" name="partner_name" v-model="partner_name"
                       :placeholder="word.your_partner_name">
                <small
                        v-if="errors && errors.partner_name"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.partner_name[0]}}
                </small>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <input type="email" class="form-control" id="email" name="email" v-model="email"
                       :placeholder="word.your_email">
                <small
                        v-if="errors && errors.email"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.email[0]}}
                </small>
            </div>
            <div class="form-group col-6">
                <input type="text" class="form-control" id="partner_email" name="partner_email" v-model="partner_email"
                       :placeholder="word.your_partner_email">
                <small
                        v-if="errors && errors.partner_email"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.partner_email[0]}}
                </small>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-6">
                <datepicker class="form-control" id="first_meet_date" name="first_meet_date" v-model="first_meet_date"
                            :place-holder="text.when_did_you_first_meet"></datepicker>
                <small
                        v-if="errors && errors.first_meet_date"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.first_meet_date[0]}}
                </small>
            </div>
            <div class="form-group col-6">
                <datepicker class="form-control" id="wedding_date" name="wedding_date" v-model="wedding_date"
                            :place-holder="word.your_wedding_date"></datepicker>
                <small
                        v-if="errors && errors.wedding_date"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.wedding_date[0]}}
                </small>
            </div>
        </div>
        <div class="row">
            <div class="form-group col-12">
                                    <textarea type="text" rows="10" class="form-control" id="story" name="story"
                                              v-model="story"
                                              :placeholder="text.how_to_met_place_holder">
                                    </textarea>
                <small
                        v-if="errors && errors.story"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.story[0]}}
                </small>
            </div>
        </div>
        <div v-if="image_step < 3" class="row justify-content-end ml-3 mr-3">
            <button class="btn btn-info" @click="addMorePhoto()"><i class="fas fa-plus"></i> {{word.add_more_photos}}</button>
        </div>
        <div class="row mt-5 ml-3 mr-3">
            <div class="col-6 d-flex justify-content-start">
                <h6 class="text-muted">{{text.add_couple_or_wedding_photos}}:</h6>
            </div>
            <div class="col-6 d-flex justify-content-start">
                <input type="file" name="image" id="image" class="story-image-input" ref="image"
                       @change="selectImage()"/>
                <small
                        v-if="errors && errors.image"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.image[0]}}
                </small>
            </div>
        </div>

        <div v-if="image_step > 0 && image_step < 4" class="row mt-5 ml-3 mr-3">
            <div class="col-6 d-flex justify-content-start">
                <h6 class="text-muted">{{text.add_couple_or_wedding_photos}}:</h6>
            </div>
            <div class="col-6 d-flex justify-content-start">
                <input type="file" name="gallery_one" id="gallery_one" class="story-image-input" ref="galleryOne"
                       @change="selectGalleryOne()"/>
                <small
                        v-if="errors && errors.gallery_one"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.gallery_one[0]}}
                </small>
            </div>
        </div>

        <div v-if="image_step > 1 && image_step < 4" class="row mt-5 ml-3 mr-3">
            <div class="col-6 d-flex justify-content-start">
                <h6 class="text-muted">{{text.add_couple_or_wedding_photos}}:</h6>
            </div>
            <div class="col-6 d-flex justify-content-start">
                <input type="file" name="gallery_two" id="gallery_two" class="story-image-input" ref="galleryTwo"
                       @change="selectGalleryTwo()"/>
                <small
                        v-if="errors && errors.gallery_two"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.gallery_two[0]}}
                </small>
            </div>
        </div>

        <div v-if="image_step === 3" class="row mt-5 ml-3 mr-3">
            <div class="col-6 d-flex justify-content-start">
                <h6 class="text-muted">{{text.add_couple_or_wedding_photos}}:</h6>
            </div>
            <div class="col-6 d-flex justify-content-start">
                <input type="file" name="gallery_three" id="gallery_three" class="story-image-input" ref="galleryThree"
                       @change="selectGalleryThree()"/>
                <small
                        v-if="errors && errors.gallery_three"
                        class="text-danger"
                        style="font-size:11px;"
                >{{errors.gallery_three[0]}}
                </small>
            </div>
        </div>

        <div class="row justify-content-center mt-5">
            <button class="btn save-story-btn" @click="submit()">{{word.send}}</button>
        </div>

    </div>
</template>

<script>
    import Swal from "sweetalert2";

    export default {
        props:['url'],
        data() {
            return {
                errors: null,
                word: window.word,
                text: window.text,
                loading: false,
                fields: {},
                name: null,
                partner_name: null,
                email: null,
                partner_email: null,
                story: null,
                image: null,
                gallery_one: null,
                gallery_two: null,
                gallery_three: null,
                first_meet_date: null,
                wedding_date: null,
                image_step: 0,
            }
        },
        methods: {
            addMorePhoto: function () {
                if (this.image_step < 3) {
                    this.image_step++;
                }
            }
            ,
            selectImage: function () {
                this.image = this.$refs.image.files[0]
            }
            ,
            selectGalleryOne: function () {
                this.gallery_one = this.$refs.galleryOne.files[0]
            }
            ,
            selectGalleryTwo: function () {
                this.gallery_two = this.$refs.galleryTwo.files[0]
            }
            ,
            selectGalleryThree: function () {
                this.gallery_three = this.$refs.galleryThree.files[0]
            }
            ,
            submit: function () {
                let self = this;
                let formData = new FormData();

                self.loading = true;

                if (self.name != null || self.name != undefined) {
                    self.fields.name = self.name;
                }

                if (self.partner_name != null || self.partner_name != undefined) {
                    self.fields.partner_name = self.partner_name;
                }

                if (self.email != null || self.email != undefined) {
                    self.fields.email = self.email;
                }

                if (self.partner_email != null || self.partner_email != undefined) {
                    self.fields.partner_email = self.partner_email;
                }

                if (self.story != null || self.story != undefined) {
                    self.fields.story = self.story;
                }

                if (self.image != null || self.image != undefined) {
                    self.fields.image = self.image;
                }

                if (document.getElementById("first_meet_date").getElementsByTagName('input')[0].value) {
                    self.fields.first_meet_date = document.getElementById("first_meet_date").getElementsByTagName('input')[0].value;
                }

                if (document.getElementById("wedding_date").getElementsByTagName('input')[0].value) {
                    self.fields.wedding_date = document.getElementById("wedding_date").getElementsByTagName('input')[0].value;
                }

                if (self.gallery_one != null || self.gallery_one != undefined) {
                    self.fields.gallery_one = self.gallery_one;
                }

                if (self.gallery_two != null || self.gallery_two != undefined) {
                    self.fields.gallery_two = self.gallery_two;
                }

                if (self.gallery_three != null || self.gallery_three != undefined) {
                    self.fields.gallery_three = self.gallery_three;
                }

                for (let key in self.fields) {
                    formData.append(key, self.fields[key]);
                }

                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                axios.post(
                    self.url,
                    formData,
                    config
                )
                    .then(function (res) {
                        if (res.data.ok) {
                            self.$toast.success(res.data.msg);
                            self.loading = false;
                        } else {
                            self.$toast.error(self.text.something_is_wrong_try_again_later);
                            self.loading = false;
                        }
                    })
                    .catch(function (e) {
                        self.errors = e.response.data.errors;
                        self.loading = false;
                    });
            }
        }
    }
</script>

<style scoped>
    .save-story-btn {
        background-color: #e30613;
        box-shadow: 0 0 3px 0 #b70912;
        color: #fff;
        padding: 8px 0;
        width: 100px;
    }
</style>